import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import {
  getAgilePurchaseHeadingLvlOne,
  getAgilePurchaseHeadingLvlTwo,
  getAgilePurchaseHeadingLvlThree,
  getAgilePurchaseHeadingLvlFour,
  getAgilePurchaseSearchProducts
} from '../../services/agilePurchase'

export const AGILE_PURCHASE_TRADED_PRODUCTS = 'AGILE_PURCHASE_TRADED_PRODUCTS'
export const AGILE_PURCHASE_TRADED_PRODUCTS_SUCCESS = 'AGILE_PURCHASE_TRADED_PRODUCTS_SUCCESS'
export const AGILE_PURCHASE_TRADED_PRODUCTS_ERROR = 'AGILE_PURCHASE_TRADED_PRODUCTS_ERROR'

export const onGetAgilePurchaseTradedProducts = makeActionCreator(AGILE_PURCHASE_TRADED_PRODUCTS)
export const onGetAgilePurchaseTradedProductsSuccess = makeActionCreator(
  AGILE_PURCHASE_TRADED_PRODUCTS_SUCCESS,
  'payload'
)
export const onGetAgilePurchaseTradedProductsError = makeActionCreator(AGILE_PURCHASE_TRADED_PRODUCTS_ERROR, 'payload')

const SERVICES_DICTIONARY = {
  1: getAgilePurchaseHeadingLvlOne,
  2: getAgilePurchaseHeadingLvlTwo,
  3: getAgilePurchaseHeadingLvlThree,
  4: getAgilePurchaseHeadingLvlFour
}

export const onGetAgilePurchaseTradedProductsThunk = payload => async dispatch => {
  dispatch(onGetAgilePurchaseTradedProducts())

  try {
    const region = payload.region === '0' ? 30 : payload.region
    const response = await SERVICES_DICTIONARY[payload.level]({
      year: payload.year,
      region,
      headingFatherId: payload.headingFatherId
    })

    const data = response.data?.payload

    const formattedData = data
      .slice(0, 10)
      .map(item => ({
        amount: item.monto,
        amountUSD: item.montoUSD,
        name: item.rubro,
        rubroId: item.rubroId,
        headingFatherId: item.headingFatherId || null,
        region: item.region,
        regionId: item.idRegion,
        orders: item.cantidad,
        level: payload.level
      }))
      .sort((a, b) => b.amount - a.amount)

    return batch(() => {
      dispatch(onGetAgilePurchaseTradedProductsSuccess({ data: formattedData }))
    })
  } catch (error) {
    dispatch(onGetAgilePurchaseTradedProductsError({ error: 'Error al obtener datos', data: [] }))
  }
}

export const AGILE_PURCHASE_TRADED_SEARCH_PRODUCTS = 'AGILE_PURCHASE_TRADED_SEARCH_PRODUCTS'
export const AGILE_PURCHASE_TRADED_SEARCH_PRODUCTS_SUCCESS = 'AGILE_PURCHASE_TRADED_SEARCH_PRODUCTS_SUCCESS'
export const AGILE_PURCHASE_TRADED_SEARCH_PRODUCTS_ERROR = 'AGILE_PURCHASE_TRADED_SEARCH_PRODUCTS_ERROR'

export const onGetAgilePurchaseTradedSearchProducts = makeActionCreator(AGILE_PURCHASE_TRADED_SEARCH_PRODUCTS)
export const onGetAgilePurchaseTradedSearchProductsSuccess = makeActionCreator(
  AGILE_PURCHASE_TRADED_SEARCH_PRODUCTS_SUCCESS,
  'payload'
)
export const onGetAgilePurchaseTradedSearchProductsError = makeActionCreator(
  AGILE_PURCHASE_TRADED_SEARCH_PRODUCTS_ERROR,
  'payload'
)

export const onGetAgilePurchaseTradedSearchProductsThunk = () => async dispatch => {
  dispatch(onGetAgilePurchaseTradedSearchProducts())

  try {
    const response = await getAgilePurchaseSearchProducts()
    const data = response.data?.payload
    const options = data.map(result => ({
      cat: result.nivel,
      name: result.rubro,
      value: result.idRubro,
      headingFather: result.idRubroPadre
    }))
    return batch(() => {
      dispatch(onGetAgilePurchaseTradedSearchProductsSuccess({ options: options }))
    })
  } catch (error) {
    dispatch(onGetAgilePurchaseTradedSearchProductsError({ error: 'Error al obtener datos', options: [] }))
  }
}
